import Swiper from "../../external/swiper";
import {HoverBlock} from "../Blocks/HoverBlock";

export class WorkSlider
{
    constructor(workSliderNode)
    {
        this.root_node = workSliderNode;

        if(!this.root_node) return

        this.items = Array.from(this.root_node.querySelectorAll('.work__item'));

        this.slider_node = this.root_node.querySelector('.swiper-container');

        this.init_hover_blocks();
        this.init_slider();
    }

    init_slider()
    {
        this.slider = new Swiper(this.slider_node, {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 32,
            navigation: {
                nextEl: this.root_node.querySelector('.pagination-button--next'),
                prevEl: this.root_node.querySelector('.pagination-button--prev')
            }
        });
    }

    init_hover_blocks(){
        const hover_effects = Array.from(this.root_node.querySelectorAll('.hover-block__block'));
        hover_effects.forEach((item) => {
            new HoverBlock(item, 50);
        })
    }
}
